export enum AnnuityType {
  FA = "Fixed Annuity",
  EIA = "Equity Index Annuity",
  SPIA = "Single Premium Immediate Annuity"
}
